// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SELLER_SHOW_OLDER = "Zobraz star\u0161\u00ed";
export const BAZAAR_SELLER_SHOW_OLDER_THAN_3_MONTHS = "Zobraz star\u0161\u00ed v\u00edce ne\u017e 3 m\u011bs\u00edce";
export const BZ2_REVIEWS_FROM_BUYERS = "Od kupuj\u00edc\u00edch";
export const BZ2_REVIEWS_FROM_SELLERS = "Od prodejc\u016f";
export const BZ2_SHOW_REVIEWS_FROM = "Zobrazit hodnocen\u00ed:";
export const THE_SELLER_HAS_NO_REVIEWS = "Zat\u00edm \u017e\u00e1dn\u00e1 hodnocen\u00ed";
